import { connect } from 'react-redux';
import DemoPage from '../../../components/pages/tmp/demo/Demo.page.jsx';


class DemoContainer extends React.Component {

    render() {
        const {} = this.props;

        return (
            <DemoPage/>
        );
    }
}


const mapStateToProps = (state, props) => ({});

const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(DemoContainer);



// WEBPACK FOOTER //
// ./app/containers/pages/tmp/Demo.container.jsx